import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import AddEditSection from './advancedPackComponents/AddEditSection';
import ProductProp, { PACK_TYPE } from '../../propTypes/productProp';
import { useModal } from '../../../../services/customHooks';
import AddPackProduct from './advancedPackComponents/AddPackProduct';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import PackVariation from './PackVariation';
import ShopProductVariationQuantity from '../ShopProductVariationQuantity';
import translate from '../../../../commonComponents/translate';

function AdvancedPack(props) {
  const {
    t,
    product,
    packVariations,
    onChangeVariations,
    stockManagementMessage,
    packQuantity,
    onPackQuantityChange,
  } = props;
  const { isPack, pack = {} } = product;

  const { loggedUser } = useContext(LoggedUserContext);
  const [modal, showModal] = useModal({ show: false, data: null });

  if (!(isPack && pack?.packType === PACK_TYPE.ADVANCED_PACK)) {
    return null;
  }

  const handleCloseModal = useCallback(
    products => {
      showModal({ show: false, data: null });
      if (products?.length > 0) {
        onChangeVariations(products);
      }
    },
    [showModal, onChangeVariations],
  );

  const handleOpenModal = useCallback(
    action => {
      showModal({
        show: true,
        data: action === 'add' ? [] : packVariations,
      });
    },
    [showModal, packVariations],
  );

  return (
    <section className="advancedPack">
      {modal?.show && (
        <AddPackProduct
          product={product}
          user={loggedUser}
          onClose={handleCloseModal}
          selectedVariations={packVariations}
        />
      )}
      <AddEditSection
        isEditable={packVariations?.length > 0}
        pack={pack}
        openModal={handleOpenModal}
      />
      {packVariations.map(packVariation => (
        <PackVariation
          key={packVariation._id}
          packVariation={{
            ...packVariation,
            variation: packVariation,
          }}
          stockManagementMessage={stockManagementMessage}
          {...props}
        />
      ))}
      <div className="product-info-item variation">
        <div className="product-info-wrapper">
          <div className="pack-quantity-wrapper">
            <p className="pack-quantity">{t('shop.pack.quantity')}</p>
            <ShopProductVariationQuantity
              index={1}
              handleChange={onPackQuantityChange}
              variation={product}
              currentVariation={{ ...product, amount: packQuantity }}
              isTouched
              showLabel={false}
              hideMinusButtonThreshold={1}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

AdvancedPack.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductProp.propType).isRequired,
  packVariations: PropTypes.arrayOf({
    variation: PropTypes.string,
    quantity: PropTypes.number,
  }),
  onChangeVariations: PropTypes.func.isRequired,
  stockManagementMessage: PropTypes.func.isRequired,
  onPackQuantityChange: PropTypes.func.isRequired,
  packQuantity: PropTypes.number,
};
AdvancedPack.defaultProps = {
  packVariations: [],
  packQuantity: 0,
};

export default translate(AdvancedPack);
